import React from 'react';
import { Formik } from 'formik';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import FormWrapper from '~FormWrapper';
import GroupEmailsForm from './GroupEmailsForm';

import { useOnSubmit, useOnEdit } from '~hooks';
import { removeEmptyKeys } from '../validations';

const validEmailRegex =
  /^.+@(pirha\.fi|sydansairaala\.fi|fimlab\.fi|coxa\.fi)$/;

const validate = values => {
  const errors = {};

  if (!values.groupType) {
    errors.groupType = 'Vaadittu';
  }

  if (!values.groupName) {
    errors.groupName = 'Vaadittu';
  }

  if (!values.groupEmail) {
    errors.groupEmail = 'Vaadittu';
  }

  if (!validEmailRegex.test(values.groupEmail)) {
    errors.groupEmail = 'Tarkista sähköpostiosoitteen muoto';
  }

  if (!values.costCenter) {
    errors.costCenter = 'Vaadittu';
  }

  if (!values.groupOwner1) {
    errors.groupOwner1 = 'Vaadittu';
  }

  if (!values.groupOwner2) {
    errors.groupOwner2 = 'Vaadittu';
  }

  if (!values.groupUsers || !values.groupUsers.length) {
    errors.groupUsers = 'Vaadittu';
  }

  return removeEmptyKeys(errors);
};

const GroupEmails = props => {
  const { formId, edit } = props;
  const { orderId } = useParams();

  const userOrganization = useSelector(
    state => state.user?.data?.ordererOrganization
  );

  const initialValues = {
    groupType: null,
    groupName: '',
    groupEmail: '',
    groupOwner1: null,
    groupOwner2: null,
    groupUsers: null,
    costCenter: {
      value: userOrganization?.costCentreId,
      label: `${userOrganization?.costCentreCode} ${userOrganization?.costCentreTitle}`,
    },
  };

  const onFormSubmit = useOnSubmit();
  const onFormEdit = useOnEdit();

  return (
    <Formik
      initialValues={initialValues}
      validate={validate}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);
        const method = edit ? onFormEdit : onFormSubmit;
        await method({
          fields: {
            ...values,
            groupOwner1: values.groupOwner1?.fullObject,
            groupOwner2: values.groupOwner2?.fullObject,
            groupUsers: values.groupUsers?.map(user => user.fullObject),
            costCenter: values.costCenter?.value,
          },
          setSubmitting,
          orderId,
          formId,
        });
      }}
    >
      {formikProps => (
        <FormWrapper
          {...props}
          title="Ryhmäsähköpostilaatikot"
          formik={formikProps}
          Component={GroupEmailsForm}
        />
      )}
    </Formik>
  );
};

export default GroupEmails;
